<div class="loader-bg col-12" style="z-index: 1" *ngIf="showSearchLoader">
  <span class="loader"><span class="loader-inner"></span></span>
</div>

<!-- item list -->
<div class="col-10 p-0 items-bg">
    <div *ngIf="seacrhAct">
      <h1 class="fontLobster" *ngIf="searchItem!=''">Search Results</h1>
      <h5 class="itemFound" *ngIf="searchItem!=''">{{items.length}} <span *ngIf="items.length > 1 || items.length==0">Results</span> <span *ngIf="items.length === 1">Result</span></h5>
     </div>
     <div *ngIf="searchItem!=''">
    <div class="item-bg p-0 animated fadeIn"  *ngFor="let item of items">
      <div class="link-to-item-details" routerLink="/items/detail/{{item.zf_id}}/{{replaceWithDash(item.zf_name) | lowercase}}">

        <div class="row imageBg">
          <!-- <img src="{{environment.s3ItemThumbImageLarge}}{{item.zf_image_web}}"> -->
          <img src="{{environment.itemCropThumbnailUrl}}{{item.zf_image_web}}">
        </div>
        <div class="category-detail-bg pl-3 pr-3 pt-3">
          <p class="menuDescription">{{item.zf_name}}</p>
          <div class="menuContainsBg">
              <p class="menuContains">
                  <span *ngIf="item.zf_allergens.length">
                    Contains:
                    <span *ngFor="let allergen of item.zf_allergens; let last = last;">
                      {{allergen.zf_name}}
                      <span *ngIf="!last">,</span>
                    </span>
                  </span>
                </p>
          </div>
        </div>
      </div>
      <div class="category-detail-bg pl-3 pr-3 pt-3">
        <span class="single-item-seperator"></span>
        <div class="category-detail-bottom">
          <p class="menuPrice m-0">{{item.zf_price | currency}}</p>
          <div>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/search/search.component.html